import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vcdashboard',
  templateUrl: './vcdashboard.component.html',
  styleUrls: ['./vcdashboard.component.css']
})
export class VcdashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
